import api from './_api';
import Vue from 'vue'


const postForm= async (context,payload) => {    
    let result=payload.payload
    let id=payload.id        
    try{        
        var response = await api.postForm(result,id)
        if (response) {                                         
            await context.dispatch('getAll');            
            return response
        }
    }
    catch(error)  {          
        return Promise.reject(error);
    };    
};
        
const getAll = async (context) => {
    try {
        var response = await api.fetchAll()                
        context.commit('ENTITY_SET_ENTITIES',response.data)        
        return response.data
    }
    catch(error) {                        
        return Promise.reject(error)
    };    
};


const getById = async (context,payload) => {
    try {        
        var response = await api.getById(payload)                
        context.commit('ENTITY_SET_ENTITY',response.data)           
        return response.data
    }
    catch(error) {                        
        return Promise.reject(error)
    };    
};

const deleteById = async (context,payload) => {
    
    try {             
        var response = await api.deleteById(payload)     
        await context.dispatch('getAll')           
        return response.data
    }
    catch(error) {  
        
        return Promise.reject(error)
    };    
};



export default {
  getAll,
  postForm,
  getById,
  deleteById,  
};
